import type { FC } from "react";

import Typography from "@/design-system/Typography";
import * as stylex from "@stylexjs/stylex";

import {
    ComposableSpacing,
    type PropsWithStyleX,
    colors,
    genericStyles,
} from "../../../styles/tokens.stylex";

export type TextLabelAppearance = keyof typeof styleTextVariants;

interface ITextLabel extends PropsWithStyleX {
    id: string;
    variant: TextLabelAppearance;
    text?: string;
    labelText?: string;
    hideIcon?: boolean;
}

const TextLabel: FC<ITextLabel> = (props) => {
    return (
        <div {...stylex.props(styles.textLabelComponent, props.styleX)}>
            {((!props.hideIcon && props.variant === "blueBorder") || props.variant === "blueFull") && (
                <div {...stylex.props(styles.icon, props.variant === "blueBorder" && styles.iconBgWhite)} />
            )}
            {props.labelText && (
                <label
                    htmlFor={`${props.id}Label`}
                    {...stylex.props(styles.inherit, styleLabelVariants[props.variant])}
                >
                    {props.labelText}
                </label>
            )}
            {props.text && (
                <Typography
                    id={props.id}
                    textElement="span"
                    styleX={[styles.inherit, styleTextVariants[props.variant]]}
                >
                    {props.text}
                </Typography>
            )}
        </div>
    );
};

const styleLabelVariants = stylex.create({
    blueFull: {
        color: "#626263",
        margin: 0,
        marginRight: ComposableSpacing.s1,
    },

    blueBorder: {
        color: "#626263",
        margin: 0,
        marginRight: ComposableSpacing.s1,
    },

    whiteBig: {
        color: "#fff",

        fontSize: ".875rem",
        margin: 0,
        marginRight: ComposableSpacing.s1,
    },

    gray: {
        color: "#999",
        margin: 0,
        marginRight: ComposableSpacing.s1,
    },
});

const styleTextVariants = stylex.create({
    blueFull: {
        color: "black",
        fontWeight: "bold",
        wordBreak: "break-word",
    },

    blueBorder: {
        color: "black",
        fontWeight: "bold",
        wordBreak: "break-word",
    },

    whiteBig: {
        color: "#fff",
        fontWeight: "bold",
        wordBreak: "break-word",
    },

    gray: {
        color: "#999",
        wordBreak: "break-word",
    },
});

const styles = stylex.create({
    textLabelComponent: {
        paddingBottom: ComposableSpacing.s1,
        paddingLeft: 0,
        paddingRight: 0,
        paddingTop: ComposableSpacing.s1,
    },

    icon: {
        backgroundColor: colors.b_BrandNavy,
        borderColor: colors.b_BrandNavy,
        borderRadius: genericStyles.borderRadiusFullRound,
        borderStyle: "solid",
        borderWidth: 1,
        display: "inline-block",
        height: 10,
        marginRight: ComposableSpacing.s1,
        width: 10,
    },

    iconBgWhite: {
        backgroundColor: "#fff",
    },

    inherit: {
        fontSize: "inherit",
        fontWeight: "inherit",
    },
});

export default TextLabel;
